import axios from "axios";
const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;
// NOTE: withCredentials must stay false. The backend CORS is configured with
// Access-Control-Allow-Origin: * which is incompatible with credentialed requests.
// Auth uses Bearer tokens via the Authorization header (set below), not cookies.
export const api = axios.create({ baseURL: API, withCredentials: false });
api.interceptors.request.use((c) => {
  // Don't override Authorization if it's already set (for admin requests)
  if (!c.headers.Authorization) {
    const t = localStorage.getItem("aabb_token");
    if (t) c.headers.Authorization = `Bearer ${t}`;
  }
  // Anonymous intake session — sent on every request so /intake/results
  // can look up the submission without relying on cookies (withCredentials is off).
  const intakeSession = localStorage.getItem("aabb_intake_session");
  if (intakeSession) c.headers["X-Intake-Session"] = intakeSession;
  return c;
});
